// // hooks/useImpersonation.js
// //
// // App.js mein sirf 2 lines add karni hain:
// //
// //   import useImpersonation from "./hooks/useImpersonation";
// //
// //   function App() {
// //     useImpersonation();   // ← bas yahi ek line
// //     ...
// //   }
// //
// // Koi alag route nahi banana — ye hook automatically
// // URL mein ?impersonate= param detect karta hai, chahe koi bhi
// // route ho (/, /dashboard, etc.)

// import { useEffect, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import useUser from "../Store/Context/UserContext";

// const API_BASE = process.env.REACT_APP_API_BASE_URL;

// const useImpersonation = () => {
//   const navigate = useNavigate();
//   const hasRun = useRef(false); // Strict mode double-fire se bachao
// const { user, setUser } = useUser();

//   useEffect(() => {
//     if (hasRun.current) return;

//     const params = new URLSearchParams(window.location.search);
//     const impersonateToken = params.get("impersonate");

//     // Normal user — kuch mat karo
//     if (!impersonateToken) return;
//     if(impersonateToken){
//         console.log("[Impersonation] Token detected, processing impersonation...");
//         localStorage.clear();
//         sessionStorage.clear();
//     }

//     hasRun.current = true;

//     // ─── Token URL se turant hata do ─────────────────────────────
//     // (Token URL bar mein visible na rahe)
//     params.delete("impersonate");
//     window.history.replaceState(
//       {},
//       "",
//       window.location.pathname +
//         (params.toString() ? `?${params.toString()}` : "")
//     );

//     const processImpersonation = async () => {
//       try {
//         const res = await axios.post(
//           `${API_BASE}/admin/verify-impersonation`,
//           { token: impersonateToken }
//         );

//         if (res.status !== 200 || !res.data.token) {
//           console.error("[Impersonation] Invalid response");
//           navigate("/", { replace: true });
//           return;
//         }

//         const { token, user, isAdminImpersonation } = res.data;

//         // ─── Step 1: Pehle sab clear karo (same as SignUp OTP verify) ──
//         localStorage.clear();
//         sessionStorage.clear();

//         // ─── Step 2: Token set karo ────────────────────────────────────
//         localStorage.setItem("token", token);
//         setUser(user);
//         // ─── Step 3: User details set karo (SignUp.js ke saath exact match) ─
//         localStorage.setItem(
//           "onboardComplete",
//           user?.verifyDetails ? "true" : "false"
//         );

//         if (user?.email) {
//           localStorage.setItem("userEmail", user.email);
//         }

//         if (user?.showreferralfloating !== undefined) {
//           localStorage.setItem(
//             "showreferralfloating",
//             user.showreferralfloating
//           );
//         }

//         // ─── Step 4: Admin impersonation flag ──────────────────────────
//         // (Optional: Dashboard mein banner dikhane ke liye)
//         if (isAdminImpersonation) {
//           localStorage.setItem("isAdminImpersonation", "true");
//           localStorage.setItem("impersonatedUserEmail", user?.email || "");
//         }

//         // ─── Step 5: Navigate — same logic as SignUp.js ────────────────
//         // Admin ke liye paymentDone/agent flow skip karte hain
//         // Sirf verifyDetails check karo
//         const isOnboardComplete = !!user?.verifyDetails;

//         // navigate(isOnboardComplete ? "/fast-agent-detail" : "/details", {
//         //   replace: true,
//         // });
//         window.location.href = isOnboardComplete ? "/fast-agent-detail" : "/details";

//       } catch (err) {
//         const errorMsg =
//           err?.response?.data?.error ||
//           "Admin login failed. Token may have expired (60s window).";

//         console.error("[Impersonation] Error:", errorMsg);

//         // User ko "/" pe bhejo error ke saath
//         navigate(
//           `/?impersonation_error=${encodeURIComponent(errorMsg)}`,
//           { replace: true }
//         );
//       }
//     };

//     processImpersonation();
//   }, []); // Sirf mount pe ek baar — no dependencies needed
// };

// export default useImpersonation;

// hooks/useImpersonation.js
//
// ROOT CAUSE FIX:
// Pehle wali problem:
//   1. URL: /?impersonate=TOKEN (User A logged in)
//   2. Onboarding child effect fires FIRST → localStorage mein User A ka token milta hai
//      → navigate("/fast-agent-detail") → URL change
//   3. useImpersonation effect fires BAAD MEIN → URL already /dashboard, no ?impersonate=
//      → impersonation kabhi hoti hi nahi!
//   4. User A apne dashboard pe apna data dekhta rehta hai
//
// FIX:
//   Token check + localStorage.clear() SYNCHRONOUSLY karo (useEffect ke bahar)
//   Taaki jab Onboarding mount ho, use koi purana token mile hi nahi

import { useEffect, useRef } from "react";
import axios from "axios";
import useUser from "../Store/Context/UserContext";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

// ─── SYNCHRONOUS CHECK — module load hote hi chalta hai ────────────────────
// useEffect ka wait nahi karta — Onboarding se PEHLE kaam karta hai
const _params        = new URLSearchParams(window.location.search);
const _impersonToken = _params.get("impersonate");

if (_impersonToken) {
  // ✅ Token URL se turant hata do (User ko URL mein nahi dikhna chahiye)
  _params.delete("impersonate");
  window.history.replaceState(
    {},
    "",
    window.location.pathname +
      (_params.toString() ? `?${_params.toString()}` : "")
  );

  // ✅ Purani session turant saaf karo
  // Ab Onboarding mount hogi → localStorage.getItem("token") → NULL milega
  // → Onboarding redirect NAHI karega → impersonation smoothly chalegi
  localStorage.clear();
  sessionStorage.clear();

  // ✅ Impersonation flag — useEffect mein processing ke liye
  window.__pendingImpersonationToken = _impersonToken;
}
// ───────────────────────────────────────────────────────────────────────────

const useImpersonation = () => {
  const hasRun       = useRef(false);
  const { setUser }  = useUser();

  useEffect(() => {
    if (hasRun.current) return;

    // Synchronous block ne token save kiya tha — ab process karo
    const impersonateToken = window.__pendingImpersonationToken;

    if (!impersonateToken) return; // Normal user — kuch mat karo

    hasRun.current = true;
    delete window.__pendingImpersonationToken; // Cleanup

    const processImpersonation = async () => {
      try {
        const res = await axios.post(
          `${API_BASE}/admin/verify-impersonation`,
          { token: impersonateToken }
        );

        if (res.status !== 200 || !res.data.token) {
          console.error("[Impersonation] Invalid response from server");
          window.location.href = "/";
          return;
        }

        const { token, user: impersonatedUser, isAdminImpersonation } = res.data;

        // ─── localStorage already cleared hai (sync block mein) ───────────
        // Sirf naye values set karo

        // 1. Token
        localStorage.setItem("token", token);

        // 2. User details — SignUp.js ke saath exact match
        localStorage.setItem(
          "onboardComplete",
          impersonatedUser?.verifyDetails ? "true" : "false"
        );

        if (impersonatedUser?.email) {
          localStorage.setItem("userEmail", impersonatedUser.email);
        }

        if (impersonatedUser?.showreferralfloating !== undefined) {
          localStorage.setItem(
            "showreferralfloating",
            impersonatedUser.showreferralfloating
          );
        }

        // 3. Admin impersonation flag (dashboard banner ke liye)
        if (isAdminImpersonation) {
          localStorage.setItem("isAdminImpersonation", "true");
          localStorage.setItem(
            "impersonatedUserEmail",
            impersonatedUser?.email || ""
          );
        }

        // 4. UserContext update
        if (impersonatedUser) {
          setUser({
            name:    impersonatedUser.name    || "",
            profile: impersonatedUser.profile || "images/camera-icon.avif",
            subscriptionDetails: {},
          });
        }

        // 5. Full page reload — Zustand stores, socket, sab fresh ho jayega
        //    navigate() use NAHI karte — stale state bachti thi
        const isOnboardComplete = !!impersonatedUser?.verifyDetails;
        window.location.href = isOnboardComplete ? "/fast-agent-detail" : "/details";

      } catch (err) {
        const errorMsg =
          err?.response?.data?.error ||
          "Admin login failed. Token may have expired (60s window).";

        console.error("[Impersonation] Error:", errorMsg);
        window.location.href = `/?impersonation_error=${encodeURIComponent(errorMsg)}`;
      }
    };

    processImpersonation();
  }, []); // Sirf mount pe ek baar
};

export default useImpersonation;